import React, { useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../../contexts/LanguageContext';

const formatAmount = (value) => {
    if (value == null) return '-';
    return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};

const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

const CariDetailReportTable = ({
    rows = [],
    loading = false
}) => {
    const { th } = useLanguage();

    const indexedRows = useMemo(() =>
        rows.map((row, index) => ({ ...row, _rowIndex: index })),
        [rows]
    );

    const amountTemplate = (rowData) => (
        <span className="font-semibold">
            {formatAmount(rowData.amount)}
        </span>
    );

    const runningBalanceTemplate = (rowData) => (
        <span className="font-semibold">
            {formatAmount(rowData.runningBalance)}
        </span>
    );

    const transactionDateTemplate = (rowData) => (
        <span>{formatDate(rowData.transactionDate)}</span>
    );

    const maturityDateTemplate = (rowData) => (
        <span>{formatDate(rowData.maturityDate)}</span>
    );

    return (
        <DataTable
            value={indexedRows}
            dataKey="_rowIndex"
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            defaultSortField="transactionDate"
            defaultSortOrder={-1}
            loading={loading}
            tableStyle={{ minWidth: '120rem' }}
            showGridlines
            stripedRows
            sortMode="single"
            emptyMessage={th('common.noData') || 'Kayıt bulunamadı'}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate={th('table.paginatorTemplate')}
            scrollable
            scrollHeight="flex"
        >
             <Column
                field="sapDealerId"
                header={th('cariDetailReport.sapDealerId') || 'SAP Bayi ID'}
                sortable
                style={{ minWidth: '8rem' }}
            />
            <Column
                field="fullName"
                header={th('cariDetailReport.fullName') || 'Bayi Adı'}
                sortable
                style={{ minWidth: '12rem' }}
            />
            <Column
                field="customerId"
                header={th('cariDetailReport.customerId') || 'Müşteri ID'}
                sortable
                style={{ minWidth: '8rem' }}
            />
            <Column
                field="musteriAdSoyad"
                header={th('cariDetailReport.customerName') || 'Müşteri Ad Soyad'}
                sortable
                style={{ minWidth: '12rem' }}
            />
            <Column
                field="transactionDate"
                header={th('cariDetailReport.transactionDate') || 'İşlem Tarihi'}
                body={transactionDateTemplate}
                sortable
                style={{ minWidth: '9rem' }}
            />
            <Column
                field="maturityDate"
                header={th('cariDetailReport.maturityDate') || 'Vade Tarihi'}
                body={maturityDateTemplate}
                sortable
                style={{ minWidth: '9rem' }}
            />
            <Column
                field="paymentTypeText"
                header={th('cariDetailReport.paymentType') || 'Ödeme Tipi'}
                sortable
                style={{ minWidth: '8rem' }}
            />
            <Column
                field="moveTypeText"
                header={th('cariDetailReport.moveType') || 'Hareket Tipi'}
                sortable
                style={{ minWidth: '8rem' }}
            />
            <Column
                field="transactionTypeText"
                header={th('cariDetailReport.transactionType') || 'İşlem Tipi'}
                sortable
                style={{ minWidth: '8rem' }}
            />
            <Column
                field="amount"
                header={th('cariDetailReport.amount') || 'Tutar'}
                body={amountTemplate}
                sortable
                style={{ minWidth: '10rem' }}
            />
            <Column
                field="currency"
                header={th('cariDetailReport.currency') || 'Para Birimi'}
                sortable
                style={{ minWidth: '7rem' }}
            />
            <Column
                field="runningBalance"
                header={th('cariDetailReport.runningBalance') || 'Hesap Hareketi'}
                body={runningBalanceTemplate}
                sortable
                style={{ minWidth: '10rem' }}
            />
            <Column
                field="documentNumber"
                header={th('cariDetailReport.documentNumber') || 'Belge No'}
                sortable
                style={{ minWidth: '9rem' }}
            />
            <Column
                field="documentSerialNumber"
                header={th('cariDetailReport.documentSerialNumber') || 'Belge Seri No'}
                sortable
                style={{ minWidth: '9rem' }}
            />
            <Column
                field="description"
                header={th('cariDetailReport.description') || 'Açıklama'}
                sortable
                style={{ minWidth: '14rem' }}
            />
            <Column
                field="phoneNumber"
                header={th('cariDetailReport.phoneNumber') || 'Telefon'}
                sortable
                style={{ minWidth: '10rem' }}
            />
              <Column
                field="createdName"
                header={th('cariDetailReport.createdUser') || 'Oluşturan'}
                sortable
                style={{ minWidth: '10rem' }}
            />
        </DataTable>
    );
};

export default CariDetailReportTable;
